import { z } from 'zod';

import { GenderEnum } from '../../enums';
import {
  levelEnumValidator,
  optionalImageUrlValidator,
  uuidValidator,
} from '../../validators';

import { ResourceLinkSchema } from './resource-link.dto';
import { TranslationsSchema } from './translation.dto';
export const CreateWordSchema = z
  .object({
    gender: z.nativeEnum(GenderEnum).optional(),
    imageUrl: optionalImageUrlValidator,
    level: levelEnumValidator.optional(),
    notes: z.string().optional().nullable(),
    partizip2: z.string().nullable().optional(),
    plural: z.string().optional(),
    prateritum: z.string().nullable().optional(),
    resourceLinks: z.array(ResourceLinkSchema).optional(),
    text: z.string().min(1, 'Text cannot be empty'),
    translations: TranslationsSchema,
    wordGroupIds: z.array(uuidValidator).optional(),
  })
  .superRefine((data, ctx) => {
    const enHasNoun = data.translations?.EN?.some(
      (translation) => translation.partOfSpeech === 'Noun',
    );
    const ruHasNoun = data.translations?.RU?.some(
      (translation) => translation.partOfSpeech === 'Существительное',
    );

    if ((enHasNoun || ruHasNoun) && !data.gender) {
      ctx.addIssue({
        message:
          'Gender is required when translation type is Noun or Существительное.',
        code: z.ZodIssueCode.custom,
        path: ['gender'],
      });
    }

    const enHasVerb = data.translations?.EN?.some(
      (translation) => translation.partOfSpeech === 'Verb',
    );
    const ruHasVerb = data.translations?.RU?.some(
      (translation) => translation.partOfSpeech === 'Глагол',
    );

    if ((enHasVerb || ruHasVerb) && (!data.prateritum || !data.partizip2)) {
      ctx.addIssue({
        message:
          'Präteritum and Partizip II are required when translation type is Verb or Глагол.',
        code: z.ZodIssueCode.custom,
        path: ['prateritum'],
      });
      ctx.addIssue({
        message:
          'Präteritum and Partizip II are required when translation type is Verb or Глагол.',
        code: z.ZodIssueCode.custom,
        path: ['partizip2'],
      });
    }
  });

export type ICreateWordDto = z.infer<typeof CreateWordSchema>;
